import './start.scss';
import './app.scss';

import { loadDone } from './preload';
import MainApp from './js/MainApp';


window.addEventListener('load', () => {
    const lang = document.documentElement.getAttribute('lang');
    const main = new MainApp(lang);

    const numEl = document.querySelector('.loader-progress-num');
    const loaderEl = document.querySelector('.loader');
    const progressUpdate = (progress) => {
        numEl.innerHTML = Math.floor(progress * 100);
        loaderEl.style.setProperty('--global-loading-progress', progress);
    };

    const loadProgressUpdate = (progress) => progressUpdate(progress * 0.97);

    if (!main.available) {
        console.warn('WebGL is not available');

        loadDone(false);

        return;
    }

    main.load(loadProgressUpdate).then(() => {
        // To make a queue and delay some processes

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                main.init();
                requestAnimationFrame(() => {
                    main.ready();

                    setTimeout(async () => {
                        await loadDone(true, progressUpdate);

                        main.start();

                        // GTM
                    }, 200);
                });
            });
        });
    }, () => {
        console.warn('App has not been loaded');
        // Error
        // Display a message on Error

        loadDone(false);
    });
});
